//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import dayjs from "dayjs";
import { commonApi } from "@/common/index";
import Back from "@/common/components/back/index.vue";
export default {
  name: "dailyDraw",
  components: {
    Back,
  },
  data() {
    return {
      activeTab: 1,
      diamondNum: 0, // 钻石数量
      goldChestCount: 0, // 当前可开金宝箱数量
      silverChestCount: 0, // 当前银宝箱数量,
      redPackageNum: 0, // 当前的红包雨数量,
      dzpNum: 1, // 当前的大转盘次数,
      gameDetail: null, // 规则条款
      diamondExchange: [], // 钻石兑换条件
      showAnimation: false, // 是否显示动画
      openChestType: 1, // 开宝箱类型 2：金宝箱 1：银宝箱
      animationStage: "closed", // 动画阶段
      showPrize: false, // 是否显示奖品
      prizeList: [], // 奖品列表
      prizeRecord: [], // 中奖记录
      exchangeRecord: [], // 兑换记录
      loadingHistory: false, // 是否正在加载历史记录
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
      UUID: (state) => state.UUID,
      isApp: (state) => state.isApp, //是否在app打开
    }),

    redPacketNeedDiamond() {
      return this.diamondExchange[0] ? this.diamondExchange[0].needDiamond : 0;
    },
    raffleNeedDiamond() {
      return this.diamondExchange[2] ? this.diamondExchange[2].needDiamond : 0;
    },
    redRainNeedDiamond() {
      return this.diamondExchange[1] ? this.diamondExchange[1].needDiamond : 0;
    },
  },
  activated() {
    this.queryRaffleData();
  },
  deactivated() {
    this.activeTab = 1;
    this.showPrize = false;
    this.showAnimation = false;
    this.animationStage = "closed";
    this.loadingHistory = false;
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;

      if (index === 0) {
        this.getPrizeRecord();
      } else if (index === 2) {
        this.getExchangeRecord();
      }
    },
    queryRaffleData() {
      commonApi.HOMEAFTER.queryDailyDraw({
        UUID: this.UUID,
      })
        .then((res) => {
          const { code, data, msg } = res;
          if (code === 200) {
            this.diamondNum = data.diamondNum || 0;
            this.goldChestCount = data.goldChestCount || 0;
            this.silverChestCount = data.silverChestCount || 0;
            this.redPackageNum = data.redPackageNum || 0;
            this.dzpNum = data.dzpNum || 0;
            this.gameDetail = data.gameDetail || null;
            this.diamondExchange = data.diamondExchange || [];
          } else {
            this.$toast({
              message: msg,
              icon: "warning",
            });

            this.$router.replace("/My");
          }
        })
        .catch((err) => {
          this.$toast({
            message: err,
            icon: "warning",
          });
          this.$router.replace("/My");
        });
    },
    handleOpenChest(type) {
      if (
        (type === 1 && this.silverChestCount <= 0) ||
        (type === 2 && this.goldChestCount <= 0)
      ) {
        this.$toast("今日已开完");
        return;
      }

      if (type === 1) {
        this.silverChestCount = this.silverChestCount - 1;
      } else if (type === 2) {
        this.goldChestCount = this.goldChestCount - 1;
      }

      commonApi.HOMEAFTER.openChest({
        UUID: this.UUID,
        chestType: type,
      })
        .then((res) => {
          const { code, data, msg } = res;
          if (code === 200) {
            this.prizeList = data || [];
            if (this.activeTab === 0) {
              this.getPrizeRecord();
            }
          } else {
            this.$toast({
              message: msg,
              icon: "warning",
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err,
            icon: "warning",
          });
        });

      this.openChestType = type;
      this.animationStage = "closed";
      this.showAnimation = true;

      requestAnimationFrame(() => {
        setTimeout(() => {
          this.animationStage = "opening";
        }, 500); // 等待 500ms 再开始打开箱子的动画

        setTimeout(() => {
          this.showPrize = true;
        }, 3000);

        setTimeout(() => {
          this.animationStage = "opened";
          this.queryRaffleData();
        }, 5000); // 5 秒后显示完全打开的宝箱
      });
    },
    closeAnimation() {
      this.showAnimation = false;
      this.showPrize = false;
      this.animationStage = "closed";
    },
    handleExchange(type) {
      if (
        (type === 1 && this.redPacketNeedDiamond > this.diamondNum) ||
        (type === 2 && this.redRainNeedDiamond > this.diamondNum) ||
        (type === 3 && this.raffleNeedDiamond > this.diamondNum)
      ) {
        // this.$toast("钻石数量不足");
        return;
      }
      const loadingToast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      commonApi.HOMEAFTER.exchangeDiamond({
        UUID: this.UUID,
        exchangeType: type,
        exchangeNum: 1,
      })
        .then((res) => {
          loadingToast.clear();
          const { code, msg } = res;
          if (code === 200) {
            this.$toast.success("兑换成功，奖品已发放至您的账户，请注意查收");
            this.queryRaffleData();
            if (this.activeTab === 2) {
              this.getExchangeRecord();
            }
          } else {
            this.$toast({
              message: msg,
              icon: "warning",
            });
          }
        })
        .catch((err) => {
          loadingToast.clear();
          this.$toast({
            message: err,
            icon: "warning",
          });
        });
    },
    getPrizeRecord() {
      this.loadingHistory = true;
      commonApi.HOMEAFTER.queryDailyDrawRecord({
        UUID: this.UUID,
      })
        .then((res) => {
          const { code, data, msg } = res;
          this.loadingHistory = false;
          if (code === 200) {
            this.prizeRecord = data;
          } else {
            this.prizeRecord = [];
          }
        })
        .catch(() => {
          this.loadingHistory = false;
          this.prizeRecord = [];
        });
    },
    getExchangeRecord() {
      this.loadingHistory = true;
      commonApi.HOMEAFTER.queryDailyDrawExchangeRecord({
        UUID: this.UUID,
      })
        .then((res) => {
          const { code, data } = res;
          this.loadingHistory = false;
          if (code === 200) {
            this.exchangeRecord = data;
          } else {
            this.exchangeRecord = [];
          }
        })
        .catch(() => {
          this.loadingHistory = false;
          this.exchangeRecord = [];
        });
    },
    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/dailyDraw/index.vue